var inputs = [];
var outputs = [];
var currentYear = new Date().getFullYear();
var makeYear;
var interest;
var period;
var price;
var administrationFee;
var invoiceFee;
var downPayment;
var lastPayment;
var maxLastPayment;
var isOld;

var financingAmount;
var monthlyPayment;
var realInterest;
var totalCosts;

const handleInputs = (form) => {

  if (isOld) {
    inputs['last-payment'].parentNode.classList.add('hidden');
    inputs['period-new'].parentNode.classList.add('hidden');
    inputs['period-old'].parentNode.classList.remove('hidden');
  } else {
    inputs['last-payment'].parentNode.classList.remove('hidden');
    inputs['period-new'].parentNode.classList.remove('hidden');
    inputs['period-old'].parentNode.classList.add('hidden');
  }
}

const getFinancingAmount = () => {
  // add shipment fee and additional costs if needed
  //let financingAmount = price + additionalCosts + administrationFee - getDownPayment() + shipmentFee;
  let financingAmount = price + administrationFee - downPayment;
  return financingAmount;
}

const getMonthlyPayment = (round = true) => {
  let result;
  const P = financingAmount;
  const J = lastPayment;
  const n = period;
  const i = interest / 1200 * 1;

  if (isOld) {
    result = i * ((P * Math.pow(1+i, n)) / (Math.pow(1+i, n) - 1));
  } else {
    result = i * ((P * Math.pow(1+i, n) - J) / (Math.pow(1+i, n) - 1 - i));
  }

  if (round) {
    return parseFloat(result.toFixed(2));
  } else {
    return result;
  }
}

const getRealInterest = () => {
  let result;
  const yearlyInterest = 100 * (Math.pow((1 + interest / 100 / 12), 12) - 1);
  const feeInterest = 12 / (financingAmount / 2) * invoiceFee * 100;
  result = yearlyInterest + feeInterest;

  return parseFloat(result.toFixed(2));
}

const getTotalCosts = () => {
  let result;
  // Jos viimeinen erä on erisuuri, vähennetään viimeisestä erästä normaali
  // kk erän maksu.
  /*
  let lastPaymentCost = 0;
  if (lastPayment > 0) {
    lastPaymentCost = lastPayment - monthlyPayment;
  }
  result = monthlyPayment * period + downPayment + lastPaymentCost;
  */

  // complex stuff :D
  let total_paid = (getMonthlyPayment(false) + invoiceFee) * period + lastPayment - getMonthlyPayment(false);
  result = total_paid - price + downPayment;

  return parseFloat(result.toFixed(2));
}

const handleLastPaymentInput = (downPaymentValue) => {

  const lastPaymentInput = document.querySelector('#last-payment');
  const lastPaymentOutput = lastPaymentInput.parentNode.querySelector('.output');
  
  /**
   * Jos Koko summa - käsiraha on enemmän kuin koko summa 40% niin max vika erä on summa - käsiraha
   */
  
  if (price - downPaymentValue < price * 0.4) {
    maxLastPayment = price - downPaymentValue;
  } else {
    maxLastPayment = price * 0.4;
  }

  if (lastPayment > maxLastPayment) {
    lastPayment = maxLastPayment;
    lastPaymentInput.value = lastPayment;
    lastPaymentOutput.innerHTML = lastPayment;
  }
  
  lastPaymentInput.setAttribute('max', maxLastPayment);

  if (lastPaymentOutput.getAttribute('max') === 0) {
    lastPaymentOutput.setAttribute('disabled', true);
  } else {
    lastPaymentOutput.setAttribute('disabled', false);
  }
}

const handleValues = () => {

  downPayment = parseFloat(inputs['down-payment'].value);
  lastPayment = isOld ? 0 : parseFloat(inputs['last-payment'].value);
  period = parseFloat(
    isOld
    ? inputs['period-old'].value 
    : inputs['period-new'].value
  );
  financingAmount = getFinancingAmount();
  realInterest = getRealInterest();
  monthlyPayment = getMonthlyPayment();
  totalCosts = getTotalCosts();

  outputs['downPayment'].innerHTML = downPayment;
  outputs['period'].innerHTML = period;
  outputs['interest'].innerHTML = interest;
  outputs['administrationFee'].innerHTML = administrationFee;
  outputs['invoiceFee'].innerHTML = invoiceFee;
  outputs['financingAmount'].innerHTML = financingAmount;
  for (const monthlyPaymentEl of outputs['monthlyPayments']) {
    monthlyPaymentEl.innerHTML = monthlyPayment;
  }
  outputs['realInterest'].innerHTML = realInterest;
  outputs['totalCosts'].innerHTML = totalCosts;
}

window.addEventListener('DOMContentLoaded', (e) => {
  const calculator = document.querySelector('#rahoituslaskuri');
  if (calculator) {
    const form = calculator.querySelector('form');

    outputs['monthlyPayments']= document.querySelectorAll('.js-monthly-payment-result');
    outputs['downPayment'] = document.querySelector('#down-payment-result');
    outputs['period'] = document.querySelector('#period-result');
    outputs['financingAmount'] = document.querySelector('#financing-amount-result');
    outputs['realInterest'] = document.querySelector('#real-interest-result');
    outputs['interest'] = document.querySelector('#interest-result');
    outputs['administrationFee'] = document.querySelector('#administration-fee-result');
    outputs['invoiceFee'] = document.querySelector('#invoice-fee-result');
    outputs['totalCosts'] = document.querySelector('#total-costs-result');
  
    var trigger_timer;
    for (const input of form.querySelectorAll('input')) {
      inputs[input.id] = input;
  
      if (input.getAttribute('type') === 'range') {
        input.addEventListener('input', () => {
  
          if (input.id === "down-payment") {
            handleLastPaymentInput(input.value);
          }
  
          input.parentNode.querySelector('.output').innerHTML = input.value;
          clearTimeout(trigger_timer);
          trigger_timer = setTimeout(function() {
            handleValues();
          }, 200);
        });
      }
    }
  
    administrationFee = parseFloat(inputs['administration-fee'].value);
    downPayment = parseFloat(inputs['down-payment'].value);
    lastPayment = isOld ? parseFloat(inputs['last-payment'].value) : 0;
    invoiceFee = parseFloat(inputs['invoice-fee'].value);
    makeYear = parseFloat(inputs['make-year'].value);
    price = parseFloat(inputs['price'].value);
    isOld = makeYear < currentYear - 15;
    interest = parseFloat(
      isOld 
      ? inputs['interest-old'].value 
      : inputs['interest-new'].value
    );
    period = parseFloat(
      isOld
      ? inputs['period-old'].value 
      : inputs['period-new'].value
    );
  
    handleInputs();
    handleValues();
  }
});
